module.exports = __webpack_public_path__ + "static/img/index_three_two.3c108594.png";